var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opc-global-error__cart"},[_c('div',{staticClass:"opc-global-error__cart-upper"},[_c('h2',[_vm._v(_vm._s(_vm.$t('billing.order_summary')))])]),_c('zm-skeleton',{attrs:{"rows":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }